<template>
  <div class="deployBox">
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column type="index" :index="indexMethods" width="80px" label="序号" />
        <el-table-column prop="processDefinitionName" label="名称" />
        <el-table-column prop="processDefinitionId" label="流程定义ID" />
        <el-table-column label="流程图" width="150">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="viewPic(row)">流程图</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="120px">
          <template slot-scope="{ row }">
            <el-link v-show="row.status === 0" :underline="false" type="primary" @click="deployBtn(row)">部署</el-link>
            <el-link v-show="row.status === 1" :underline="false" type="danger" @click="cancelDeployBtn(row)">取消部署</el-link>
          </template>
        </el-table-column> -->
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>

    <!-- 流程图查看 -->
    <el-dialog title="查看流程图"
      :visible.sync="imgVisible"
      width="40%">
      <el-image :src="fileField" alt="" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="innerVisible = true">全屏查看</el-button>
        <el-button type="primary" size="small" @click="imgVisible = false">确 定</el-button>
      </span>
      <!-- 全屏查看的内层弹窗 -->
      <el-dialog
        width="30%"
        title=""
        fullscreen
        :visible.sync="innerVisible"
        append-to-body>
        <el-image :src="fileField" alt="" />
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
// import { deployList, deploy, cancelDeploy } from '@/api/workStation'
// import { downLoadDocument } from '@/api/downLoad'
  import { myProcess } from "@/api/model"
  import axios from 'axios'
export default {
  name: 'workflowDeploy',
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 10,
      curPage: 1,
      fileField: null,
      imgVisible: false,
      innerVisible: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    indexMethods(index) {
      return (this.curPage - 1) * this.limit + index + 1
    },
    // 获取列表
    getData() {
      myProcess({ limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    viewPic(row) {
      let obj = new FormData()
      obj.append('processDefinitionId', row.processDefinitionId)
      obj.append('processInstanceId', row.processInstanceId)
      axios({
        method: 'post',
        url: "/v1/processinstance/processPhoto",
        responseType: 'arraybuffer',
        data: obj
      }).then(res => {
        this.fileField = 'data:image/png;base64,' + btoa(
          new Uint8Array(res.data)
            .reduce((data, byte) => data + String.fromCharCode(byte), ''))
        this.imgVisible = true
      })
    },
  }
}
</script>

<style scoped>

</style>